import React from 'react';
import './CustomDashboards.css';

// Import the new image
import dashboardImage from '../../assets/images/custom-dashboard.png';

const CustomDashboards = () => {
  return (
    <section className="custom-dashboards-section">
      <div className="custom-dashboards-container">
        {/* Left Column: Image */}
        <div className="dashboard-image-col">
          <img src={dashboardImage} alt="Customizable dashboard interface" />
        </div>

        {/* Right Column: Text Content */}
        <div className="dashboard-text-col">
          <h2>Customise your own dashboards</h2>
          <p>
            Time is money — and our custom dashboards save you both. Simply choose the data you care about, and we’ll organise it into a clean, personal view that updates automatically.
          </p>
          <p>
            No clutter, no distractions — just the numbers and insights that matter to you, all in one place.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CustomDashboards;